"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var themes = {};
var theme_895b8b110577e5d4b97199dc19c60c00_1 = require("./theme_895b8b110577e5d4b97199dc19c60c00");
themes["theme:895b8b110577e5d4b97199dc19c60c00"] = {
    theme: theme_895b8b110577e5d4b97199dc19c60c00_1.default,
    title: "Default"
};
var theme_d6715fba481f88a989270eae10e4c42f_1 = require("./theme_d6715fba481f88a989270eae10e4c42f");
themes["theme:d6715fba481f88a989270eae10e4c42f"] = {
    theme: theme_d6715fba481f88a989270eae10e4c42f_1.default,
    title: "CTA"
};
exports.default = themes;
